export default {
  reward_title: "Recompensas por invitación",
  reward_desc_dynamic:
    "Por cada amigo que invite exitosamente a registrarse, recibirá {0} créditos de cálculo como recompensa",
  invite_friend: "Invitar amigos",
  friend_email: "Correo electrónico del amigo",
  email_placeholder: "Por favor ingrese el correo electrónico de su amigo",
  send_invite: "Enviar invitación",
  invite_instructions: "Instrucciones de invitación",
  email_invitation_validity_dynamic:
    "Las invitaciones por correo electrónico son válidas por {0} días",
  link_invitation_permanent: "Las invitaciones por enlace son permanentemente válidas",
  instruction_1_dynamic:
    "Por cada invitación exitosa, usted y su amigo recibirán {0} créditos de cálculo cada uno",
  instruction_2:
    "Las recompensas se acreditan automáticamente después de que su amigo acepte la invitación y se registre exitosamente",
  instruction_3:
    "Los créditos de recompensa se pueden usar para cálculos de emisiones de carbono y son válidos según su plan de suscripción",
  invite_stats: "Estadísticas de invitación",
  total_invites: "Invitaciones totales",
  accepted_invites: "Invitaciones aceptadas",
  reward_credits: "Créditos de recompensa",
  invite_link: "Enlace de invitación personal",
  reward_rules: "Reglas de recompensa",
  reward_rule_1_dynamic:
    "Por cada invitación exitosa, recibirá {0} créditos de cálculo como recompensa",
  reward_rule_2:
    "Los créditos de recompensa se acreditan automáticamente a su cuenta y se pueden usar para cálculos de emisiones de carbono",
  reward_rule_3:
    "Nos reservamos el derecho de cancelar recompensas y bloquear cuentas si se detecta fraude",
  email_required: "Por favor ingrese una dirección de correo electrónico",
  email_invalid: "Formato de correo electrónico inválido",
  invite_sent: "Invitación enviada",
  send_failed: "Error al enviar la invitación",
  fetch_failed: "Error al obtener la información de invitación",
  copy_success: "Copiado con éxito",
  email_invitation: "Invitación por correo electrónico",
  link_invitation: "Invitación por enlace",
  status_pending: "Pendiente",
  status_accepted: "Aceptado",
  status_expired: "Expirado",
  reward_issued: "Emitido",
  pending: "Pendiente",
  reward_pending_tip:
    "Las recompensas se acreditarán después de que su amigo realice su primer cálculo",
  expiring_soon: "Próximo a expirar",
  no_invitations: "No hay registros de invitación",
  invitee_id: "ID del invitado",
  type: "Tipo de invitación",
  email: "Correo electrónico",
  status: "Estado",
  reward_status: "Estado de recompensa",
  invite_time: "Hora de invitación",
  expire_time: "Fecha de vencimiento",
  my_invitations: "Mis invitaciones",
  invite_created_title: "Enlace de invitación",
  invite_created_desc:
    "No se pudo enviar el correo electrónico. Por favor envíe manualmente el siguiente enlace a su amigo:",
  total_invitations: "Total {0} registros",
  search_invitations: "Buscar invitaciones...",
  confirm: "Confirmar",
};
